import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserAccess } from '../interfaces/state/entities/user-access.interface';
import { UserAccessStore } from '../services/user-access/user-access.store';

function roleChoiceCount(access: UserAccess): number {
  return (access.isDeveloper ? 1 : 0) + (access.isSupport ? 1 : 0) + (access.isAdmin ? 1 : 0);
}

export const roleSelectionGuard: CanActivateFn = () => {
  const store = inject(UserAccessStore);
  const router = inject(Router);

  return store.load().pipe(
    map((access) => {
      if (!access.isDeveloper && !access.isSupport && !access.isAdmin) {
        return router.parseUrl('/no-access');
      }

      if (roleChoiceCount(access) > 1) {
        return true;
      }

      if (access.isDeveloper) {
        store.setPreferredEntry('developer');
        return router.parseUrl('/projects');
      }
      if (access.isSupport) {
        store.setPreferredEntry('support');
        return router.parseUrl('/registered-applications');
      }
      store.setPreferredEntry('admin');
      return router.parseUrl('/admin');
    }),
    catchError(() => of(router.parseUrl('/no-access')))
  );
};
